module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-kids.d31d075a.jpg";